import {
  CustomButton,
  CustomCheckbox,
  CustomCollapseCard,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomInput,
  CustomTextInput,
  Text,
  useText,
} from '@src/components';
import '@src/styles/myInvoices/balanceReportFilter.scss';
import iconSearchWhite from '@src/assets/icons/icon-white-search.svg';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { cardBalancesGetList } from '@src/store/slice/cardBalancesSlice';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

const BalanceReportFilter = ({ form, segId, vouId }) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);

  const handleSearch = useCallback(async () => {
    await loadcardBalances();
  }, [dispatch]);

  const handleClear = useCallback(async () => {
    form.resetFields(['name', 'cardNumber', 'surname', 'refNo']);
    await loadcardBalances();
  }, [form]);

  const loadcardBalances = useCallback(async () => {
    const values = await form.validateFields();
    if (values?.checkText) {
      const cardNo = values?.cardNumber ? values?.cardNumber.replaceAll(/\s/g, '') : undefined;
      const refNo = values?.refNo ? values?.refNo.replaceAll(/\s/g, '') : undefined;

      const body = {
        segId: segId,
        cardNumber: cardNo || undefined,
        refNo: refNo || undefined,
        name: values?.name || undefined,
        surname: values?.surname || undefined,
        vouId: vouId,
      };
      await dispatch(cardBalancesGetList({ body }));
    }
  }, [dispatch, form]);

  return (
    <CustomCollapseCard className="balance-filter-card" cardTitle={<Text t="filters" />}>
      <CustomForm
        name="filterForm"
        className="filter-form"
        autoComplete="off"
        initialValues={{}}
        layout={'horizontal'}
        form={form}
      >
        <div className="form-item-container">
          <div className="form-items">
            <CustomFormItem
              label={
                <div>
                  <Text t="name" />
                  <span>:</span>
                </div>
              }
              name="name"
            >
              <CustomTextInput
                id="ticketRestaurant-myInvoices-balanceReport-balanceReportFilter-name-textInput"
                autoComplete="off"
                height={36}
                placeholder={useText('name3')}
                hasNumberChar={true}
              />
            </CustomFormItem>
            <CustomFormItem
              label={
                <div>
                  <Text t="surname" />
                  <span>:</span>
                </div>
              }
              name="surname"
            >
              <CustomTextInput
                id="ticketRestaurant-myInvoices-balanceReport-balanceReportFilter-surname-textInput"
                autoComplete="off"
                height={36}
                placeholder={useText('surname2')}
                hasNumberChar={true}
              />
            </CustomFormItem>
            <CustomFormItem
              label={
                <div>
                  <Text t="cardNumber2" />
                  <span>:</span>
                </div>
              }
              name="cardNumber"
            >
              <CustomInput
                id="ticketRestaurant-myInvoices-balanceReport-balanceReportFilter-cardNumber-input"
                autoComplete="off"
                placeholder={useText('cardNumber2')}
                height={36}
                hasNumberChar={true}
              />
            </CustomFormItem>
            <CustomFormItem
              label={
                <div>
                  <Text t="referenceCode2" /><span>:</span>
                </div>
              }
              name="refNo"
            >
              <CustomInput
                id="ticketRestaurant-myInvoices-balanceReport-balanceReportFilter-refNo-input"
                autoComplete="off"
                placeholder={useText('referenceCode2')}
                height={36}
                hasNumberChar={true}
              />
            </CustomFormItem>
          </div>
          <div className="form-items">
            <CustomFormItem
              label={false}
              name="checkText"
              className="check-form-item"
              valuePropName="checked"
            >
              <CustomCheckbox
                id="ticketRestaurant-myInvoices-balanceReport-balanceReportFilter-checkText-checkbox"
                onChange={(e) => setIsChecked(e?.target?.checked)}
              >
                <p>
                  <Text t="iAcceptDeclareAndUndertakeThatIAm" />
                </p>
                <p>
                  <Text t="dueToThisReportRequestIAcceptDeclare" />
                </p>
              </CustomCheckbox>
            </CustomFormItem>
          </div>

          <div className="form-buttons">
            <div className="action-buttons">
              <CustomButton
                id="ticketRestaurant-myInvoices-balanceReport-balanceReportFilter-clear-btn"
                className="clear-btn"
                onClick={handleClear}
              >
                <Text t="clean" />
              </CustomButton>
              <CustomButton
                id="ticketRestaurant-myInvoices-balanceReport-balanceReportFilter-search-btn"
                className="search-btn"
                onClick={handleSearch}
                disabled={!isChecked}
              >
                <CustomImage className="icon-search" src={iconSearchWhite} /> <Text t="search" />
              </CustomButton>
            </div>
          </div>
        </div>
      </CustomForm>
    </CustomCollapseCard>
  );
};
BalanceReportFilter.propTypes = {
  form: PropTypes.object.isRequired,
  segId: PropTypes.number.isRequired,
  vouId: PropTypes.string.isRequired,
};

export default BalanceReportFilter;
